import { c as _c } from "react/compiler-runtime";
import { MessageCircleIcon, PinIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
export function Pinned() {
  const $ = _c(14);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-linear-to-br from-blue-50 via-purple-50 to-rose-50 dark:from-blue-900/20 dark:via-purple-900/20 dark:to-rose-900/10" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute top-4 right-4"><PinIcon className="size-5 rotate-45 text-muted-foreground" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="hidden size-10 shrink-0 items-center justify-center rounded-full bg-muted sm:flex"><MessageCircleIcon className="size-5 text-primary" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("guestbook.pinned.greeting");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <h2 className="text-xl font-semibold">{t3}</h2>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("guestbook.pinned.description");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <p className="text-sm text-muted-foreground">{t5}</p>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="relative overflow-hidden rounded-2xl border text-card-foreground">{t0}{t1}<div className="relative p-4"><div className="flex items-start gap-4">{t2}<div className="space-y-4">{t4}{t6}</div></div></div></div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}